export const Routes = {
  AGREEMENT: 'agreement',
  CHANGELOG_CREATE: 'changelogCreate',
  CHANGELOG_EDIT: 'changelogEdit',
  CHANGELOG_LIST: 'changelogList',
  COACHING: 'coaching',
  COOKBOOK: 'cookbook',
  COOKBOOK_SHOW: 'cookbookShow',
  COURSE_EDIT: 'courseEdit',
  COURSE_LIST: 'courseList',
  CUSTOMER_CREATE: 'customerCreate',
  CUSTOMER_EDIT: 'customerEdit',
  CUSTOMER_LIST: 'customerList',
  DIARY: 'diary',
  DIARY_SHOW: 'diaryShow',
  FILE_SYSTEM_LIST: 'fileSystemList',
  LIVE_COACHING: 'liveCoaching',
  LOGIN: 'login',
  MODULE_CHAPTER_STEP_CREATE: 'moduleChapterStepCreate',
  MODULE_CHAPTER_STEP_EDIT: 'moduleChapterStepEdit',
  MODULE_CHAPTER_STEP_MODULE_PREVIEW_SHOW: 'moduleChapterStepModulePreviewShow',
  MODULE_CHAPTER_STEP_USER_EXAM: 'moduleChapterStepUserExam',
  MODULE_CHAPTER_STEP_USER_SHOW: 'moduleChapterStepUserShow',
  MODULE_EDIT: 'moduleEdit',
  MODULE_LIST: 'moduleList',
  MODULE_PREVIEW: 'modulePreview',
  NOT_FOUND: 'notFound',
  OIDC_CALLBACK: 'oidcCallback',
  NOTIFICATION: 'notification',
  MAINTENANCE: 'maintenance',
  PASSWORD: 'password',
  PASSWORD_FORGOT: 'passwordForgot',
  PASSWORD_FORGOT_CONFIRM: 'passwordForgotConfirm',
  RECIPE_CREATE: 'recipeCreate',
  RECIPE_EDIT: 'recipeEdit',
  RECIPE_LIST: 'recipeList',
  RECIPE_SEARCH: 'recipeSearch',
  RECIPE_SHOW: 'recipeShow',
  REGISTER: 'register',
  REGISTER_CONFIRM: 'registerConfirm',
  SETTINGS: 'settings',
  CONTRACT: 'contract',
  INDIVIDUAL_COACHING: 'individualCoaching',
  INDIVIDUAL_COACHING_CLIENT: 'individualCoachingClient',
  INDIVIDUAL_COACHING_MINE: 'individualCoachingMine',
  STATISTIC: 'statistic',
  STATISTIC_DEVICE: 'statisticDevice',
  STATISTIC_USER: 'statisticUser',
  STATISTIC_USER_ONLINE_TIME: 'statisticUserOnlineTime',
  STATISTIC_OVERVIEW: 'statisticOverview',
  STATISTIC_CLIENTS: 'statisticClients',
  STATISTIC_CLIENT_DETAIL: 'statisticClientDetail',
  STATISTIC_AT_RISK: 'statisticAtRisk',
  STATISTIC_FUNNEL: 'statisticFunnel',
  STATISTIC_FUNNEL_DETAIL: 'statisticFunnelDetail',
  STATISTIC_RETENTION: 'statisticRetention',
  STATISTIC_ACTIVATION: 'statisticActivation',
  STATISTIC_DIARY_RESPONSE: 'statisticDiaryResponse',
  STATISTIC_BAND_TREND: 'statisticBandTrend',
  STATISTIC_LIFECYCLE: 'statisticLifecycle',
  COACHING_PROFILE: 'coachingProfile',
  COACHING_PROFILE_ONBOARDING: 'coachingProfileOnboarding',
  COACHING_PROFILE_SEARCH: 'coachingProfileSearch',
  USER_CREATE: 'userCreate',
  USER_DASHBOARD: 'userDashboard',
  USER_DIARY: 'userDiary',
  USER_EDIT: 'userEdit',
  USER_LIST: 'userList',
  USER_MODULE_SHOW: 'userModuleShow',
  USER_MODULES: 'userModules',
  USER_PROFILE: 'userProfile',
  USER_PROGRESS: 'userProgress',
  WHATS_NEW: 'whatsNew',
} as const;
